

const section = {
    computed: {
        modify () {
            return this.$route.path.split('/').map(token => token.toLowerCase()).some(token => token === 'modify')
        },
        checkupNo () {
            return Number(this.$route.params.checkupNo) || null
        }
    }
}

export default section
